module.exports = __webpack_public_path__ + "img/header-module.db676c3e.png";